var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 8H4.88889C4.39797 8 4 8.48842 4 9.09091V12.9091C4 13.5116 4.39797 14 4.88889 14H11.1111C11.602 14 12 13.5116 12 12.9091V9.09091C12 8.48842 11.602 8 11.1111 8Z",
    stroke: "#9DA1AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18518 7.70304V5.46436C5.18518 4.7222 5.48369 4.01043 6.01504 3.48563C6.5464 2.96084 7.26706 2.66602 8.01851 2.66602C8.76996 2.66602 9.49062 2.96084 10.022 3.48563C10.5533 4.01043 10.8518 4.7222 10.8518 5.46436V7.70304",
    stroke: "#9DA1AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0b0fbc0e9c17a379d92c6ed6a013b8ed.svg";
export { ForwardRef as ReactComponent };